import React from 'react';
import { Container, Typography, Card, CardContent, Grid } from '@mui/material';

export default function AboutUs() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, sm: 16 } }}>
      <Typography variant="h3" align="left" gutterBottom>
        About Us
      </Typography>
      <Typography variant="h6" align="left" color="textSecondary" paragraph>
        At FalconXcellence, we specialize in delivering high-quality software solutions across
        multiple platforms, including full-stack web development, mobile applications, Windows
        desktop applications, cloud computing, and distributed systems.
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Full-Stack Development
              </Typography>
              <Typography variant="body2" color="textSecondary">
                We build robust and scalable web applications using the latest frontend and backend
                technologies.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Mobile Development
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Our expertise in iOS and Android development ensures seamless, high-performance
                mobile applications.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Windows Desktop Apps
              </Typography>
              <Typography variant="body2" color="textSecondary">
                We develop powerful and user-friendly Windows applications tailored to your business
                needs.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Cloud Applications
              </Typography>
              <Typography variant="body2" color="textSecondary">
                We design and deploy scalable, secure, and efficient cloud-based solutions for
                businesses of all sizes.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Distributed Systems
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Our team builds high-performance, distributed systems that enhance reliability and
                scalability.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
